'use client'

import React from 'react'
import { formatDayMonthYearUTC } from '../utils/date-formater'
import { useSiteContext } from '@dustin-web/microsite-components/src/hooks'
import { getCultureCode, getDefaultLanguage } from '@dustin-web/microsite-config'
type Props = {
  isoDate?: string
  className?: string
}

export const ArticleDate = ({ isoDate, className = '' }: Props) => {
  const { site } = useSiteContext()

  if (!isoDate) {
    return null
  }

  const language = getDefaultLanguage(site)
  const cultureCode = getCultureCode(language)
  return <p className={className}>{formatDayMonthYearUTC(isoDate, cultureCode)}</p>
}
